/* NDC: personalizator cu machetă live. Fișier propriu numeredecasa.ro (nu face parte din Horizon).
   Etapa 4 (26.09): două moduri – data-mode="live" (SolarisLux: machetă generată pe loc) și
   data-mode="manual" (celelalte produse: clientul scrie textul, macheta o trimitem noi pe WhatsApp).
   29.09: live și pentru Luxury (familia NERO) – motor separat NDCMachetaLux (data-engine-global);
   cadrul (plăcuță / inserție) și culorile vin din varianta aleasă (opțiunea „Model”), codul așezării = cadru + A/B (ex. NA).
   01.10: previzualizare pe pozele reale (data-lux-photos) + cutiile poștale (data-lux-product = cutie-mare / cutie-mica).
   01.10 (b): cutiile pe același flux ca Luxury (fără data-final="whatsapp" în temă; codul rămâne suportat);
   numele de familie poate fi și bifă gratuită, fără variantă (cutii) → nu se sincronizează cu nicio variantă.
   02.10: PABLO / PABLITO pe același motor (data-lux-product = pablo / pablito; plăcuțe orizontale, fără poze).
   02.10 (b): „Culoare șuruburi” (Negre / Aurii / Argintii) la PABLO / PABLITO → proprietate în comandă + previzualizare
   (nu cere reconfirmarea machetei: fișierul de decupare nu se schimbă).
   02.10 (c): REX (data-lux-product = rex) – „Siluetă” (Doberman / Pisică) → proprietate în comandă + parametrul an= în link;
   silueta intră în fișierul de decupare, deci schimbarea ei cere reconfirmarea machetei.
   02.10 (d): Razoare (data-lux-product = razoare, cod ZA) – al doilea font (data-font2-url, Archivo Black pentru număr);
   culoarea inserției după varianta „Model” (Auriu / Argintiu); așezarea e fixă (Număr sus + Altă variantă).
   03.10: Luxury 25 × 35 cm – opțiunea „Mărime” (data-lux-size-option, prima opțiune a produsului) → cadrul L (cod LA/LB);
   „Model” se citește după nume, nu după poziție; nota de mărime din data-size-note-big.
   10.10: Finisaj și la toate cutiile poștale (clasice + Pomul Vieții) – vine din Liquid (data-finish); loguri [NDC-PERSO].
   10.10 (b): cutiile cu Pomul Vieții live (data-lux-product = cutie-mare-pom / cutie-mica-pom → cadrele V / W, coduri VA / WA / WB);
   la cutia mică cu pom așezarea B („stradă și număr pe un rând”) e permisă oricând. Etichetele VA/WA/WB = NDC_MAN.ASEZARE (NDC-manual.gs).
   17.10 (HU): Családnév fără „Fam.” – „Kovács” devine „Kovács család” (previzualizare + comandă), log [NDC-PERSO-HU] családnév.
   16.10 (HU, /hu-hu/): textele vin din data-i18n (JSON, doar pe HU; gol = textele RO de mai jos) prin T(cheie, textRO);
   valorile alese de client în HU (Model, Mărime, Felület, Csavarszín, Sziluett) se traduc înapoi în RO prin data-ro-map,
   ca motorul, pozele și linkul machetei (m=, fin=, su=, an=) să primească exact valorile RO de până acum;
   radio-urile Finisaj / Șuruburi / Siluetă se găsesc după data-ndc-finish / data-ndc-screw / data-ndc-icon (nu după numele proprietății,
   care în HU e altul); proprietatea de confirmare = data-k-confirm. Loguri [NDC-PERSO-HU].
   27.10: NOVA (placa semnalistică, data-engine-global = NDCMachetaNova, data-lux-product = nova, coduri OA / OB):
   mărimea din opțiunea „Size” (luxVariant), Font (Cu serife / Fără serife → data-font2-url), Culoare text, Culoare șuruburi,
   Finisaj în previzualizare, logo încărcat de client (properties[Logo], fișier; previzualizare monocromă în culoarea textului).
   27.10 seara: taxa de logo = opțiunea de variantă „Logo” (Fără logo / Cu logo, selector ascuns; data-logo-option) – se comută
   automat la încărcarea / scoaterea fișierului; bifa „Linie de demarcație” (data-ndc-rule, parametrul ln=0 când e scoasă).
   27.10 seara (2): câmp separat „Număr” (data-ndc-number, properties[Număr]) cu zonă fixă sus în machetă; număr SAU text SAU logo.
   Text SAU logo e suficient. Logo / font / mărime / așezare schimbate = reconfirmare; culoare / finisaj / șuruburi = fără. Loguri [NDC-PERSO][NOVA].
   28.10 (HU NOVA): pe /hu-hu/ radio-urile Font / Culoare text au valori HU (Talpas, Arany…) + data-ro cu valoarea RO → textColor() / fontSel()
   întorc RO pentru motor și linkul machetei; mărimea HU („30x40 cm álló”) → RO prin data-ro-map; textele NOVA prin T('nova_*'); mesajele
   de eroare ale motorului (RO) → HU (logoErrMsg). Loguri [NDC-PERSO-HU] NOVA.
   data-kind: casa | cutie | apartament | placa (ce câmpuri sunt obligatorii). */
(function () {
  'use strict';

  var BUY_SELECTOR = [
    '.add-to-cart-button',
    '.shopify-payment-button',
    '[data-ndc-buy]',
    '[class*="releasit" i]',
    '[id*="releasit" i]',
    '[class*="_rsi-" i]',
    '#rsi_buy_now_button',
    '[id^="rsi_" i]'
  ].join(',');

  var LAYOUT_LABEL_RO = {
    A: 'A – număr sus, stradă jos',
    B: 'B – stradă | număr',
    B2: 'B – număr | stradă',
    C: 'C – un singur rând de informații',
    X: 'Altă variantă – macheta pe WhatsApp'
  };
  ['N', 'I', 'H', 'L', 'M', 'C', 'P', 'Q', 'R', 'Z'].forEach(function (f) { LAYOUT_LABEL_RO[f + 'A'] = LAYOUT_LABEL_RO.A; LAYOUT_LABEL_RO[f + 'B'] = 'B – stradă sus, număr jos'; });
  // 10.10 (b): Pomul Vieții – aceleași texte ca NDC_MAN.ASEZARE din NDC-manual.gs
  // 12.10: cutia mare – 2 așezări (Adi): standard (pom 10–13 cm) / mare (pom până la 15 cm, text mai mic)
  LAYOUT_LABEL_RO.VA = 'Pom dimensiune standard – familie, linie, pom, stradă, număr';
  LAYOUT_LABEL_RO.VB = 'Pom dimensiune mare – pom până la 15 cm, text mai mic';
  LAYOUT_LABEL_RO.WA = 'Pomul Vieții – pom, linie, stradă, număr mare';
  LAYOUT_LABEL_RO.WB = 'Pomul Vieții – pom, linie, stradă și număr pe un rând';
  // 27.10: NOVA
  LAYOUT_LABEL_RO.OA = 'Centrat – logo (dacă există) sus, text dedesubt';
  LAYOUT_LABEL_RO.OB = 'Logo în stânga, text în dreapta';
  var OTHER = 'X';
  var CONFIRM_PROP_RO = 'properties[Machetă confirmată]';

  var loads = (window.__ndcLoads = window.__ndcLoads || {});
  function loadScript(src) {
    if (!loads[src]) {
      loads[src] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return loads[src];
  }

  function val(el) { return el && !el.disabled ? String(el.value || '') : ''; }

  function init(root) {
    if (root.__ndcReady) return;
    root.__ndcReady = true;

    /* ---------- 16.10 HU: texte + traducerea valorilor înapoi în RO ---------- */
    var I18N = {};
    try { I18N = JSON.parse(root.dataset.i18n || '{}'); } catch (e) { console.log('[NDC-PERSO-HU] data-i18n invalid', e); }
    var RO_MAP = {};
    try { RO_MAP = JSON.parse(root.dataset.roMap || '{}'); } catch (e) { console.log('[NDC-PERSO-HU] data-ro-map invalid', e); }
    var hu = root.dataset.lang === 'hu';
    function T(key, ro) { return Object.prototype.hasOwnProperty.call(I18N, key) ? I18N[key] : ro; }
    function ro(v) {
      v = v == null ? '' : String(v);
      if (Object.prototype.hasOwnProperty.call(RO_MAP, v)) {
        if (hu) console.log('[NDC-PERSO-HU] valoare HU → RO:', v, '→', RO_MAP[v]);
        return RO_MAP[v];
      }
      return v;
    }
    var LAYOUT_LABEL = {};
    Object.keys(LAYOUT_LABEL_RO).forEach(function (k) { LAYOUT_LABEL[k] = T('layout_' + k, LAYOUT_LABEL_RO[k]); });
    ['N', 'I', 'H', 'L', 'M', 'C', 'P', 'Q', 'R', 'Z'].forEach(function (f) { LAYOUT_LABEL[f + 'A'] = LAYOUT_LABEL.A; LAYOUT_LABEL[f + 'B'] = T('layout_FB', LAYOUT_LABEL_RO[f + 'B']); });
    var CONFIRM_PROP = root.dataset.kConfirm ? 'properties[' + root.dataset.kConfirm + ']' : CONFIRM_PROP_RO;

    var q = function (sel) { return root.querySelector(sel); };
    var live = root.dataset.mode !== 'manual';
    var kind = root.dataset.kind || 'casa';
    var form = document.getElementById(root.dataset.formId);
    var section = root.closest('.shopify-section') || document;
    var street = q('[data-ndc-street]');
    var number = q('[data-ndc-number]');
    var textEl = q('[data-ndc-text]');
    var fam = q('[data-ndc-family]');
    var famToggle = q('[data-ndc-fam-toggle]');
    var famField = q('[data-ndc-fam-field]');
    var other = q('[data-ndc-other]');
    var otherField = q('[data-ndc-other-field]');
    var confirmBox = q('[data-ndc-confirm]');
    var confirmText = q('[data-ndc-confirm-text]');
    var echo = q('[data-ndc-echo]');
    var errorEl = q('[data-ndc-error]');
    var layoutValue = q('[data-ndc-layout-value]');
    var linkInput = q('[data-ndc-link]');
    var preview = q('[data-ndc-preview]');
    var caption = q('[data-ndc-caption]');
    var nightBtn = q('[data-ndc-night]');
    var layoutNote = q('[data-ndc-layout-note]');
    var layoutRadios = root.querySelectorAll('[data-ndc-layouts] input[type="radio"]');
    var photo = root.dataset.photoUrl || '';
    var engineGlobal = root.dataset.engineGlobal || 'NDCMacheta';
    var lux = engineGlobal === 'NDCMachetaLux';
    var luxOpt = root.dataset.luxOption || 'Model';
    var luxMap = {};
    try { luxMap = JSON.parse(root.dataset.luxVariants || '{}'); } catch (e) {}
    var luxProduct = root.dataset.luxProduct || '';
    var luxSizeOpt = root.dataset.luxSizeOption || '';
    var luxSizes = {};
    try { luxSizes = JSON.parse(root.dataset.luxSizes || '{}'); } catch (e) {}
    var sizeNoteBig = root.dataset.sizeNoteBig || '';
    var photos = {};
    try { photos = JSON.parse(root.dataset.luxPhotos || '{}'); } catch (e) {}
    var finalWa = root.dataset.final === 'whatsapp'; // previzualizare orientativă, macheta finală pe WhatsApp
    var sizeNote = root.dataset.sizeNote || T('size_note_default', 'Așa va arăta caseta ta (față decupată 278 × 146 mm).');
    var svcBoxes = root.querySelectorAll('[data-ndc-service]');
    var screwRadios = root.querySelectorAll('input[data-ndc-screw]');
    var iconRadios = root.querySelectorAll('input[data-ndc-icon]');
    var finishRadios = root.querySelectorAll('input[data-ndc-finish]');
    var noun = root.dataset.noun || 'produsul';
    // 27.10: NOVA
    var nova = engineGlobal === 'NDCMachetaNova';
    var colorRadios = root.querySelectorAll('input[data-ndc-color], input[name="properties[Culoare text]"]'); // 28.10 HU: după data-ndc-color (numele proprietății e altul pe HU)
    var fontRadios = root.querySelectorAll('input[data-ndc-font], input[name="properties[Font]"]'); // 28.10 HU: după data-ndc-font
    var logoInput = q('[data-ndc-logo]');
    var logoBox = q('[data-ndc-logo-box]');
    var logoLabel = q('[data-ndc-logo-label]');
    var logoRemove = q('[data-ndc-logo-remove]');
    var logoDefaultLabel = logoLabel ? logoLabel.textContent : '';
    var logo = null; // { kind: 'image'|'file', name, ar, mask } – NDCMachetaNova.prepareLogo
    var pendingLogo = null; // fișier ales înainte să se încarce motorul
    var ruleBox = q('[data-ndc-rule]');
    var logoOpt = root.dataset.logoOption || ''; // opțiunea de variantă „Logo” (taxa de 9,90 lei)
    var logoOn = root.dataset.logoOn || 'Cu logo';
    function nlog() { try { console.log.apply(console, ['[NDC-PERSO][NOVA]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {} }
    var engine = null;
    var night = false;
    var timer = null;
    var result = null;

    /* ---------- varianta „Nume de familie” ---------- */
    var famOption = root.dataset.famOption;
    var famValue = root.dataset.famValue;

    function famRadios() {
      return Array.prototype.slice.call(
        section.querySelectorAll('input[type="radio"][data-option-name="' + CSS.escape(famOption) + '"]')
      );
    }

    function setFamVariant(on) {
      var radios = famRadios();
      var target = radios.filter(function (r) { return on ? r.value === famValue : r.value !== famValue; })[0];
      if (target && !target.checked) target.click();
    }

    function syncFamFromVariant() {
      if (!famToggle) return;
      var radios = famRadios();
      if (!radios.length) return; // bifă gratuită (cutii): nu există variantă de sincronizat
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var on = !!checked && checked.value === famValue;
      if (famToggle.checked !== on) {
        famToggle.checked = on;
        applyFamUi();
      }
    }

    function applyFamUi() {
      if (!famToggle) return;
      var on = famToggle.checked;
      famField.hidden = !on;
      fam.disabled = !on;
      if (!on) fam.value = '';
    }

    /* ---------- stare ---------- */
    function selectedLayout() {
      var r = Array.prototype.filter.call(layoutRadios, function (x) { return x.checked; })[0];
      return r ? r.value : 'A';
    }

    function isOther() { return live && selectedLayout() === OTHER; }

    // „Altă variantă” (live), modul manual și data-final="whatsapp": fără proprietatea „Machetă confirmată”
    function applyOtherUi() {
      var on = isOther();
      root.classList.toggle('ndc-perso--other', on);
      if (otherField) otherField.hidden = !on;
      if (other) other.disabled = !on;
      if (confirmText) {
        confirmText.textContent = !live ? T('confirm_text_manual', 'Am verificat textul scris, literă cu literă.')
          : on ? T('confirm_text_other', 'Am descris varianta dorită.')
          : finalWa ? T('confirm_text_wa', 'Am verificat textul și previzualizarea.') : T('confirm_text_live', 'Am verificat macheta și o confirm.');
      }
      if (on || !live || finalWa) confirmBox.removeAttribute('name');
      else confirmBox.setAttribute('name', CONFIRM_PROP);
    }

    // NDC 17.10 (HU): numele de familie = „Kovács család” (motorul nu mai pune „Fam.” în față când se termină în „család”);
    //   dacă clientul scrie doar „Kovács”, adăugăm „ család” – se vede în machetă și așa intră în comandă.
    function famHu(v) {
      var t = String(v || '').replace(/\s+/g, ' ').trim();
      if (!hu || !t || /(^|\s)csal[aá]d$/i.test(t) || /^fam(\.|ilia)?\s/i.test(t)) return t;
      return t + ' család';
    }
    function famHuAplica(sursa) {
      if (!hu || !fam || fam.disabled) return;
      var v = String(fam.value || ''), n = famHu(v);
      if (n && n !== v.trim()) { fam.value = n; console.log('[NDC-PERSO-HU] családnév completat (' + sursa + '):', JSON.stringify(v), '→', JSON.stringify(n)); }
    }

    function data() {
      return {
        street: val(street),
        number: val(number),
        text: val(textEl),
        family: famToggle && famToggle.checked ? (hu ? famHu(val(fam)) : val(fam)) : '',
        layout: selectedLayout(),
        icon: iconSel(),
        font: fontSel() === 'Fără serife' ? 'sans' : 'serif',
        logo: !!logo,
        logoAR: logo ? logo.ar : 0,
        rule: ruleBox && !ruleBox.checked ? 'none' : 'auto'
      };
    }

    function radioVal(list) {
      var r = Array.prototype.filter.call(list, function (x) { return x.checked; })[0];
      return r ? (r.dataset.ro || r.value) : ''; // 28.10 HU: data-ro = valoarea RO (motor + link machetă)
    }
    function textColor() { return radioVal(colorRadios); }
    function fontSel() { return radioVal(fontRadios); }

    // Luxury / cutii: valoarea opțiunii „Model” (butonul bifat; altfel după varianta din formular) – mereu în RO (16.10)
    function luxVariant() {
      var r = section.querySelector('input[type="radio"][data-option-name="' + CSS.escape(luxOpt) + '"]:checked');
      if (r) return ro(r.value);
      var idEl = (form && form.querySelector('[name="id"]')) || document.querySelector('[form="' + root.dataset.formId + '"][name="id"]');
      return ro((idEl && luxMap[String(idEl.value)]) || root.dataset.luxDefault || '');
    }

    // Luxury: valoarea opțiunii „Mărime” (butonul bifat; altfel după varianta din formular) – mereu în RO (16.10)
    function luxSize() {
      if (!luxSizeOpt) return '';
      var r = section.querySelector('input[type="radio"][data-option-name="' + CSS.escape(luxSizeOpt) + '"]:checked');
      if (r) return ro(r.value);
      var idEl = (form && form.querySelector('[name="id"]')) || document.querySelector('[form="' + root.dataset.formId + '"][name="id"]');
      return ro((idEl && luxSizes[String(idEl.value)]) || root.dataset.luxSizeDefault || '');
    }

    function engineData() {
      var d = data();
      if (lux && engine && d.layout !== OTHER) d.layout = engine.frameFor(luxVariant(), luxProduct, luxSize()) + d.layout;
      if (nova) d.size = luxVariant();
      return d;
    }

    // Silueta / șuruburile / finisajul: valoarea RO (pentru motor și linkul machetei); în comandă rămâne valoarea afișată
    function iconSel() {
      var r = Array.prototype.filter.call(iconRadios, function (x) { return x.checked; })[0];
      return r ? ro(r.value) : '';
    }

    function screws() {
      var r = Array.prototype.filter.call(screwRadios, function (x) { return x.checked; })[0];
      return r ? ro(r.value) : '';
    }

    function pv(extra) {
      var o = { night: night, photo: photo };
      if (lux) { o.variant = luxVariant(); o.size = luxSize(); o.product = luxProduct; o.photos = photos; o.screws = screws(); }
      if (nova) {
        o.size = luxVariant();
        o.color = textColor();
        o.finish = finish();
        o.screws = screws();
        o.logoUrl = logo && engine ? engine.tintLogo(logo, o.color) : '';
        o.logoName = logo ? logo.name : '';
      }
      Object.keys(extra || {}).forEach(function (k) { o[k] = extra[k]; });
      return o;
    }

    function finish() {
      var r = Array.prototype.filter.call(finishRadios, function (x) { return x.checked; })[0];
      return r ? ro(r.value) : '';
    }

    function summary() {
      var d = data();
      if (kind === 'placa') return [nova ? d.number.trim() : '', d.text.replace(/\s*\n\s*/g, ' · ').trim()].filter(Boolean).join(' · ');
      return [d.street.trim(), d.number.trim(), d.family.trim()].filter(Boolean).join(', ');
    }

    function missingText() {
      var d = data();
      if (kind === 'placa') return !d.text.trim() && !(nova && (logo || d.number.trim()));
      if (kind === 'apartament') return !d.number.trim();
      return !d.street.trim() && !d.number.trim();
    }

    function missingMsg() {
      if (kind === 'placa') return nova ? T('nova_missing', 'Scrie numărul sau textul plăcii (ori încarcă logo-ul).') : T('missing_placa', 'Scrie textul plăcii.');
      if (kind === 'apartament') return T('missing_apartament', 'Scrie numărul apartamentului.');
      return T('missing_casa', 'Completează strada sau numărul.');
    }

    function confirmMsg() {
      if (!live) return T('confirm_msg_manual', 'Bifează „Am verificat textul scris”.');
      if (isOther()) return T('confirm_msg_other', 'Bifează „Am descris varianta dorită”.');
      return finalWa ? T('confirm_msg_wa', 'Bifează „Am verificat textul și previzualizarea”.') : T('confirm_msg_live', 'Bifează „Am verificat macheta și o confirm”.');
    }

    function problems() {
      var p = [];
      if (missingText()) p.push(missingMsg());
      if (famToggle && famToggle.checked && !val(fam).trim()) p.push(T('fam_missing', 'Scrie numele de familie sau debifează opțiunea.'));
      if (isOther() && other && !other.value.trim()) p.push(T('other_missing', 'Descrie în cuvinte varianta dorită.'));
      if (nova && logoVariantOn() && !logo) p.push(T('nova_logo_missing', 'Încarcă logo-ul sau scoate-l.'));
      if (nova && logo && logoOpt && logoRadios().length && !logoVariantOn()) setLogoVariant(true);
      var vp = verifProblem(); // 29.10 #3411: verificarea textului (număr în stradă / „Nr” / număr gol)
      if (vp) p.push(vp);
      if (!confirmBox.checked) p.push(confirmMsg());
      return p;
    }

    function updateLayoutAvailability() {
      if (!live || !layoutRadios.length) return;
      if (nova) {
        // B (logo în stânga) are sens doar cu logo + text
        var okB = !!(logo && (val(textEl).trim() || val(number).trim()));
        Array.prototype.forEach.call(layoutRadios, function (r) { if (r.value === 'B') r.disabled = !okB; });
        if (!okB && selectedLayout() === 'B') layoutRadios[0].checked = true;
        if (layoutNote) {
          var nn = !logo ? T('nova_b_needs_logo', '„Logo în stânga” devine activ după ce încarci logo-ul.') : '';
          layoutNote.hidden = !nn;
          layoutNote.textContent = nn;
        }
        return;
      }
      var d = data();
      var both = !!(d.street.trim() && d.number.trim());
      var famOn = !!(famToggle && famToggle.checked);
      var pom = /-pom$/.test(luxProduct);
      var allowB = pom ? true : both && !famOn; // 10.10 (b) / 12.10: la cutiile cu pom, B (mică „pe un rând” / mare „Pom dimensiune mare”) – oricând
      try { if (pom) console.log('[NDC-PERSO] Pomul Vieții: ' + luxProduct + ' – B permis (' + (luxProduct === 'cutie-mare-pom' ? 'Pom dimensiune mare' : 'pe un rând') + ')'); } catch (e) {}
      Array.prototype.forEach.call(layoutRadios, function (r) {
        if (r.value === 'B' || r.value === 'B2') r.disabled = !allowB;
      });
      var sel = selectedLayout();
      if (!allowB && (sel === 'B' || sel === 'B2')) layoutRadios[0].checked = true;
      var note = '';
      if (famOn && both && !isOther() && !pom) note = T('layout_note_fam', 'Cu numele familiei, numărul stă sus, iar strada și numele dedesubt.');
      if (layoutNote) {
        layoutNote.hidden = !note;
        layoutNote.textContent = note;
      }
    }

    function buildLink(res) {
      if (!live || isOther() || finalWa) return '';
      try {
        var u = new URL(root.dataset.productUrl);
        var d = data();
        u.searchParams.set('view', 'macheta');
        if (d.street.trim()) u.searchParams.set('s', d.street.trim());
        if (d.number.trim()) u.searchParams.set('n', d.number.trim());
        if (d.family.trim()) u.searchParams.set('f', d.family.trim());
        u.searchParams.set('a', res ? res.layout : d.layout);
        if (lux) u.searchParams.set('m', luxVariant());
        if (finish()) u.searchParams.set('fin', finish());
        if (screws()) u.searchParams.set('su', screws());
        if (iconSel()) u.searchParams.set('an', iconSel());
        if (nova) {
          if (d.text.trim()) u.searchParams.set('t', d.text.trim());
          u.searchParams.set('m', luxVariant());
          u.searchParams.set('c', textColor());
          u.searchParams.set('fo', fontSel());
          if (logo) { u.searchParams.set('lg', logo.name); u.searchParams.set('la', String(Math.round(logo.ar * 1000) / 1000)); }
          if (ruleBox && !ruleBox.checked) u.searchParams.set('ln', '0');
        }
        var theme = window.Shopify && window.Shopify.theme;
        if (theme && theme.role && theme.role !== 'main') u.searchParams.set('preview_theme_id', theme.id);
        if (hu) console.log('[NDC-PERSO-HU] link machetă (valori RO):', u.toString());
        return u.toString();
      } catch (e) {
        return '';
      }
    }

    // Schimbă doar textul din machetă (fundalul rămâne încărcat; se redesenează tot doar la zi/noapte sau altă variantă)
    function paint(html) {
      var key = (night ? 'night' : 'day') + (lux ? '|' + luxVariant() + '|' + luxSize() + '|' + screws() : '') +
        (nova ? '|' + luxVariant() + '|' + textColor() + '|' + finish() + '|' + screws() : '');
      var cur = preview.firstElementChild;
      if (cur && cur.tagName.toLowerCase() === 'svg' && preview.dataset.key === key) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var next = tpl.content.firstElementChild;
        var oldG = cur.querySelector('[data-ndc-txt]');
        var newG = next && next.querySelector('[data-ndc-txt]');
        if (oldG && newG) {
          oldG.replaceWith(newG);
          cur.setAttribute('aria-label', next.getAttribute('aria-label') || '');
          return;
        }
      }
      preview.innerHTML = html;
      preview.dataset.key = key;
    }

    function renderManual() {
      var s = summary();
      if (echo) {
        echo.textContent = s ? '„' + s + '”' : '';
        echo.hidden = !s;
      }
    }

    function render() {
      verifRender(); // 29.10 #3411: panoul „Ce apare pe produs” + avertizări
      if (!live) { renderManual(); return; }
      updateLayoutAvailability();
      if (isOther()) {
        if (layoutValue) layoutValue.value = LAYOUT_LABEL[OTHER];
        if (linkInput) linkInput.value = '';
        result = null;
        if (engine) paint(engine.previewSvg({ paths: [], rects: [] }, pv({ message: T('wa_message', 'Revenim cu macheta pe WhatsApp'), label: T('wa_label', 'Altă variantă – macheta vine pe WhatsApp') })));
        caption.textContent = T('other_caption', 'Pentru varianta descrisă nu generăm machetă automată. Îți trimitem macheta pe WhatsApp, pentru confirmare, înainte de producție.');
        return;
      }
      if (!engine) return;
      var d = engineData();
      result = engine.layout(d);
      if (/-pom$/.test(luxProduct)) console.log('[NDC-PERSO] Pomul Vieții: cod ' + result.layout + ' | pom ' + (result.tree ? result.tree.w + ' × ' + result.tree.h + ' mm' : '-') + ' | avertizări: ' + ((result.warn || []).join(',') || '-'));
      if (result.layout === 'EMPTY') {
        paint(engine.previewSvg(nova ? result : { paths: [], rects: [] }, pv()));
        caption.textContent = nova ? T('nova_empty_caption', 'Scrie numărul și textul plăcii (sau încarcă logo-ul) ca să vezi macheta.') : (finalWa ? T('empty_caption_wa', 'Scrie strada și numărul ca să vezi previzualizarea.') : T('empty_caption', 'Scrie strada și numărul ca să vezi macheta.'));
      } else {
        paint(engine.previewSvg(result, pv({ label: (finalWa ? T('label_wa', 'Previzualizare: ') : T('label_live', 'Machetă: ')) + (nova ? summary() : [d.number, d.street, d.family].filter(Boolean).join(', ')) })));
        var msg = [];
        if (nova && result.warn.indexOf('long') >= 0) msg.push(T('nova_warn_long', 'Textul e lung, așa că literele ies mici. Împarte-l pe mai multe rânduri (Enter) sau alege o placă mai mare.'));
        else if (nova && result.warn.indexOf('small') >= 0) msg.push(T('nova_warn_small', 'Numărul e lung, așa că cifrele ies mai mici.'));
        else if (result.warn.indexOf('long') >= 0) msg.push(T('warn_long', 'Textul e lung, așa că literele ies mai mici. Poți scrie „Str.” în loc de „Strada”.'));
        else if (result.warn.indexOf('small') >= 0) msg.push(T('warn_small', 'Numărul iese mai mic, ca să încapă tot textul.'));
        if (result.chars) {
          if (I18N.chars) msg.push(I18N.chars.replace('{c}', result.chars.join(' ')));
          else msg.push('Caracterele „' + result.chars.join(' ') + '” nu există în fontul ' + (nova ? 'plăcii' : luxProduct.indexOf('cutie') === 0 ? 'cutiei' : lux ? 'plăcuței' : 'casetei') + '; le adaptăm la decupare.');
          if (hu) console.log('[NDC-PERSO-HU] caractere lipsă din font:', result.chars.join(' '));
        }
        if (nova && logo && logo.kind === 'file') msg.push(T('nova_logo_file', 'Logo-ul ({n}) nu se poate previzualiza; îl așezăm în zona marcată.').replace('{n}', logo.name));
        caption.textContent = msg.join(' ') || (nova ? T('nova_plate', 'Placa ') + engine.sizeLabel(luxVariant()) + '. ' + sizeNote : sizeNoteBig && /^L/.test(result.layout) ? sizeNoteBig : sizeNote);
        if (nova) nlog('machetă', result.layout, '| mărime', luxVariant(), '| font', d.font, '| culoare', textColor(), '| finisaj', finish(), '| șuruburi', screws(), '| logo', logo ? logo.name + ' (' + logo.kind + ', ar ' + Math.round(logo.ar * 100) / 100 + ')' : '-', '| avertizări', (result.warn || []).join(',') || '-');
      }
      if (layoutValue) layoutValue.value = result.layout === 'EMPTY' ? '' : LAYOUT_LABEL[result.layout] || result.layout;
      if (linkInput) linkInput.value = result.layout === 'EMPTY' ? '' : buildLink(result);
      if (hu) console.log('[NDC-PERSO-HU] render | cod =', result.layout, '| model RO =', lux ? luxVariant() : '-', '| mărime RO =', luxSize() || '-', '| elrendezés =', layoutValue ? layoutValue.value : '-');
    }

    function schedule(changed) {
      if (changed && confirmBox.checked) {
        confirmBox.checked = false;
        showError([!live ? T('reconfirm_manual', 'Ai modificat textul – verifică-l și bifează din nou.')
          : isOther() ? T('reconfirm_other', 'Ai modificat datele – bifează din nou „Am descris varianta dorită”.')
          : finalWa ? T('reconfirm_wa', 'Ai modificat textul – verifică previzualizarea și bifează din nou.')
          : T('reconfirm_live', 'Ai modificat macheta – verifică-o și confirm-o din nou.')]);
      } else if (!errorEl.hidden) {
        var p = problems();
        if (p.length) showError(p); else hideError();
      }
      clearTimeout(timer);
      timer = setTimeout(render, 60);
    }

    function showError(list) {
      errorEl.textContent = list.join(' ');
      errorEl.hidden = false;
      root.classList.add('ndc-perso--error');
    }
    function hideError() {
      errorEl.hidden = true;
      root.classList.remove('ndc-perso--error');
    }

    /* ---------- 29.10: VERIFICARE TEXT (reclamația #3411) ----------
       Pe produsele cu câmp „Stradă” + „Număr” prindem înainte de comandă:
       (1) numărul scris în rândul străzii („Str caramidarii noi nr 9a”) – buton „Mută în câmpul Număr”;
       (2) „Nr” / „Nr.” în câmpul Număr („Nr.43” s-ar grava mare „NR.43”) – buton „Păstrează doar 43”;
       (3) câmpul Număr gol – plăcuța iese fără număr mare (permis, dar doar cu bifă explicită);
       (4) stradă fără diacritice (doar RO) – informativ, nu blochează;
       (5) rezumatul „Ce apare pe produs: …” deasupra bifei de confirmare.
       (1)–(3) blochează comanda până la corectare sau bifa „Am înțeles, las textul așa”;
       bifa ajunge în comandă ca proprietate ascunsă „_Verificare text” (o citește Webhook-ul).
       Orice eroare aici NU blochează comanda (try/catch). Loguri: [NDC-VERIF]. */
    var verifOn = kind === 'casa' && !!street && !!number && !!confirmBox;
    var verifBox = null, verifSum = null, verifList = null, verifAckRow = null, verifAckInput = null, verifProp = null;
    var verifLast = null, verifState = { block: false, issues: [] };
    var RE_NR_IN_STREET = /^(.*?)[\s,;.\-]*\b(nr|număr|numar|no|hsz)\b\.?\s*(\d[\w\/\-]*(?:\s[\w\/\-]{1,3})?)\.?\s*$/i;
    var RE_TRAILING_NR = /^(.*?[^\d\s,;.\-])[\s,;.\-]+(\d{1,4}[a-zA-Z]?(?:\s?[\/\-]\s?\w{1,4})?)\.?\s*$/;
    var RE_NR_PREFIX = /^(nr|număr|numar|no|hsz)(?![a-zăâîșțşţ])\s*[.:]?\s*(?=\S)/i;
    function vlog() { try { console.log.apply(console, ['[NDC-VERIF]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {} }
    function VT(key, roTxt, huTxt) { return T(key, hu ? huTxt : roTxt); }
    function vUp(x) { return String(x || '').replace(/\s+/g, ' ').trim().toLocaleUpperCase(hu ? 'hu-HU' : 'ro-RO'); }

    function verifSet(el, v, why) {
      vlog('corectare la clic |', why, '|', JSON.stringify(el.value), '→', JSON.stringify(v));
      el.value = v;
      try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) { schedule(true); }
    }

    function verifCheck(d) {
      var s = d.street.trim(), n = d.number.trim(), iss = [], m, m2, m3;
      if (!s && !n) return iss;
      m = s ? s.match(RE_NR_IN_STREET) : null;
      if (m) {
        var tok = m[3].replace(/\s+/g, ' ').trim();
        var rest = m[1].replace(/[\s,;.\-]+$/, '');
        var shown = s.slice(m[1].length).replace(/^[\s,;.\-]+/, '');
        iss.push({
          k: 'inStreet', block: true, t: tok,
          msg: VT('verif_in_street', 'Ai scris numărul în rândul străzii („{t}”). Așa iese mic, ca text – nu ca număr mare.', 'A házszámot az utca sorába írtad („{t}”). Így kicsiben, szövegként jelenik meg – nem nagy számként.').replace('{t}', shown),
          fix: n ? VT('verif_fix_drop', 'Scoate „{t}” din stradă', '„{t}” törlése az utcából').replace('{t}', shown)
            : VT('verif_fix_move', 'Mută „{t}” în câmpul Număr', '„{t}” áthelyezése a szám mezőbe').replace('{t}', vUp(tok)),
          apply: function () {
            if (!n) verifSet(number, vUp(tok), 'număr mutat din stradă');
            verifSet(street, rest, 'stradă fără număr');
          },
          prop: 'număr scris în rândul străzii („' + shown + '”)' + (n ? '' : ', câmpul Număr gol')
        });
      } else if (s && !n) {
        m2 = s.match(RE_TRAILING_NR);
        iss.push({
          k: 'empty', block: true, t: m2 ? m2[2] : '',
          msg: VT('verif_empty', 'Câmpul Număr e gol: produsul va avea doar textul, fără număr mare.', 'A szám mező üres: a terméken csak a szöveg lesz, nagy szám nélkül.'),
          fix: m2 ? VT('verif_fix_move', 'Mută „{t}” în câmpul Număr', '„{t}” áthelyezése a szám mezőbe').replace('{t}', vUp(m2[2])) : null,
          apply: m2 ? function () {
            verifSet(number, vUp(m2[2]), 'număr mutat de la finalul străzii');
            verifSet(street, m2[1].replace(/[\s,;.\-]+$/, ''), 'stradă fără număr');
          } : null,
          prop: 'fără număr mare (câmpul Număr gol)'
        });
      }
      m3 = n ? n.match(RE_NR_PREFIX) : null;
      if (m3) {
        var pre = m3[1], only = n.slice(m3[0].length).trim();
        iss.push({
          k: 'nrPrefix', block: true, t: only,
          msg: VT('verif_nr_prefix', 'În câmpul Număr ai scris și „{p}”, așa că iese mare „{n}”. De obicei se scrie doar numărul.', 'A szám mezőbe ezt is beírtad: „{p}”, így nagyban ez jelenik meg: „{n}”. Általában csak a számot írják be.').replace('{p}', pre).replace('{n}', vUp(n)),
          fix: VT('verif_fix_prefix', 'Păstrează doar „{n}”', 'Csak „{n}” maradjon').replace('{n}', vUp(only)),
          apply: function () { verifSet(number, only, 'scos „' + pre + '” din număr'); },
          prop: 'număr scris cu „' + pre + '” („' + n + '”)'
        });
      }
      if (!hu && s && /[a-z]{4}/i.test(s) && !/[ăâîșțşţ]/i.test(s)) {
        iss.push({ k: 'diacritics', block: false, t: '', msg: T('verif_diacritics', 'Textul apare exact cum îl scrii. Dacă numele străzii are diacritice (ă, â, î, ș, ț), adaugă-le.'), fix: null, apply: null, prop: '' });
      }
      return iss;
    }

    function verifSummary(d) {
      var parts = [VT('verif_sum_num', 'NUMĂR: ', 'SZÁM: ') + (vUp(d.number) || VT('verif_sum_nonum', '— (fără număr)', '— (szám nélkül)'))];
      if (d.street.trim()) parts.push(VT('verif_sum_text', 'TEXT: ', 'SZÖVEG: ') + vUp(d.street));
      if (d.family && d.family.trim()) parts.push(VT('verif_sum_fam', 'FAMILIE: ', 'CSALÁD: ') + vUp(d.family));
      return VT('verif_sum', 'Ce apare pe produs: ', 'Ami a terméken megjelenik: ') + parts.join(' · ');
    }

    function verifBuild() {
      if (verifBox || !verifOn) return;
      // Panoul stă imediat sub rândul cu câmpurile Stradă + Număr (acolo se uită clientul când scrie);
      // rezervă: deasupra bifei de confirmare.
      var fields = street, after = true;
      while (fields && fields !== root && !fields.contains(number)) fields = fields.parentNode;
      if (!fields || fields === root) { fields = (confirmBox.closest && confirmBox.closest('label')) || confirmBox.parentNode; after = false; }
      if (!fields || !fields.parentNode) { verifOn = false; vlog('nu găsesc locul panoului – verificarea e oprită'); return; }
      verifBox = document.createElement('div');
      verifBox.setAttribute('data-ndc-verif', '');
      verifBox.style.cssText = 'margin:12px 0;padding:10px 12px;border:1px solid #E6DFD2;border-radius:8px;background:#F7F4EE;color:#1A1A1A;font-size:14px;line-height:1.45';
      verifBox.hidden = true;
      verifSum = document.createElement('div');
      verifSum.setAttribute('data-ndc-verif-sum', '');
      verifSum.style.cssText = 'font-weight:600;letter-spacing:.02em';
      verifList = document.createElement('div');
      verifAckRow = document.createElement('label');
      verifAckRow.style.cssText = 'display:none;gap:8px;align-items:flex-start;margin-top:10px;cursor:pointer;font-weight:600';
      verifAckInput = document.createElement('input');
      verifAckInput.type = 'checkbox';
      verifAckInput.setAttribute('data-ndc-verif-ack', '');
      verifAckInput.style.cssText = 'margin-top:3px;flex:none';
      var ackTxt = document.createElement('span');
      ackTxt.textContent = VT('verif_ack', 'Am înțeles, las textul așa', 'Értem, így hagyom a szöveget');
      verifAckRow.appendChild(verifAckInput);
      verifAckRow.appendChild(ackTxt);
      verifProp = document.createElement('input');
      verifProp.type = 'hidden';
      verifProp.name = 'properties[_Verificare text]';
      if (root.dataset.formId) verifProp.setAttribute('form', root.dataset.formId);
      verifProp.value = '';
      verifBox.appendChild(verifSum);
      verifBox.appendChild(verifList);
      verifBox.appendChild(verifAckRow);
      verifBox.appendChild(verifProp);
      fields.parentNode.insertBefore(verifBox, after ? fields.nextSibling : fields);
      vlog('panou așezat', after ? 'sub câmpurile Stradă/Număr' : 'deasupra bifei de confirmare (rezervă)');
      verifAckInput.addEventListener('change', function () {
        vlog('bifa „las textul așa” =', verifAckInput.checked ? 'DA' : 'nu', '| avertizări =', verifState.issues.map(function (i) { return i.k; }).join(',') || '-');
        verifRender();
        schedule(false);
      });
      vlog('panou creat | formular =', root.dataset.formId || '(fără)', '| HU =', hu);
    }

    function verifRender() {
      if (!verifOn) return;
      try {
        verifBuild();
        if (!verifBox) return;
        var d = data(), iss = verifCheck(d);
        var sig = iss.map(function (i) { return i.k + ':' + i.t; }).join('|') + '#' + d.street.trim() + '#' + d.number.trim();
        if (sig !== verifLast) {
          if (verifAckInput.checked) vlog('bifa „las textul așa” scoasă – textul s-a schimbat');
          verifAckInput.checked = false;
          verifLast = sig;
          vlog('verificare | stradă =', JSON.stringify(d.street), '| număr =', JSON.stringify(d.number), '| avertizări =', iss.length ? iss.map(function (i) { return i.k + (i.t ? '(' + i.t + ')' : ''); }).join(', ') : 'niciuna');
        }
        var any = !!(d.street.trim() || d.number.trim());
        var block = iss.some(function (i) { return i.block; });
        verifBox.hidden = !any;
        verifSum.textContent = any ? verifSummary(d) : '';
        verifList.textContent = '';
        iss.forEach(function (i) {
          var row = document.createElement('div');
          row.setAttribute('data-ndc-verif-issue', i.k);
          row.style.cssText = 'margin-top:8px;color:' + (i.block ? '#8A4B00' : '#5C5346');
          var t = document.createElement('div');
          t.textContent = (i.block ? '⚠️ ' : 'ℹ️ ') + i.msg;
          row.appendChild(t);
          if (i.fix && i.apply) {
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = i.fix;
            b.setAttribute('data-ndc-verif-fix', i.k);
            b.style.cssText = 'margin-top:6px;padding:5px 12px;border:1px solid #C9A24B;border-radius:6px;background:#fff;color:#1A1A1A;font-size:13px;cursor:pointer';
            b.addEventListener('click', function (ev) { ev.preventDefault(); vlog('clic corectare |', i.k, '|', i.fix); i.apply(); });
            row.appendChild(b);
          }
          verifList.appendChild(row);
        });
        verifAckRow.style.display = block ? 'flex' : 'none';
        var acked = block && verifAckInput.checked;
        verifProp.value = acked ? 'LĂSAT AȘA de client: ' + iss.filter(function (i) { return i.block; }).map(function (i) { return i.prop; }).join('; ') : '';
        verifState = { block: block, issues: iss };
      } catch (e) {
        vlog('EROARE verificare (comanda NU e blocată de verificare):', e && e.message, e);
        verifState = { block: false, issues: [] };
      }
    }

    function verifBlockingOpen() { return !!(verifOn && verifState.block && !(verifAckInput && verifAckInput.checked)); }

    function verifProblem() {
      verifRender();
      if (!verifBlockingOpen()) return '';
      vlog('comanda așteaptă corectarea sau bifa | avertizări =', verifState.issues.filter(function (i) { return i.block; }).map(function (i) { return i.k; }).join(','));
      return VT('verif_block', 'Verifică avertizarea de sub câmpurile Stradă și Număr: corectează textul sau bifează „Am înțeles, las textul așa”.', 'Ellenőrizd a figyelmeztetést az utca és a szám mező alatt: javítsd a szöveget, vagy jelöld be: „Értem, így hagyom a szöveget”.');
    }
    vlog('init | activ =', verifOn, '| tip =', kind, '| câmp stradă =', !!street, '| câmp număr =', !!number, '| HU =', hu, '| mod =', live ? 'live' : 'manual');

    /* ---------- evenimente ---------- */
    [street, number, textEl, fam, other].forEach(function (el) {
      if (el) el.addEventListener('input', function () { schedule(true); });
    });
    if (hu && fam) fam.addEventListener('change', function () { famHuAplica('change'); schedule(true); }); // NDC 17.10
    Array.prototype.forEach.call(layoutRadios, function (r) {
      r.addEventListener('change', function () {
        applyOtherUi();
        if (isOther() && other) other.focus();
        schedule(true);
      });
    });
    Array.prototype.forEach.call(finishRadios, function (r) {
      r.addEventListener('change', function () {
        if (nova) schedule(false); // NOVA: finisajul se vede în previzualizare
        if (linkInput) linkInput.value = buildLink(result);
        console.log('[NDC-PERSO] finisaj ales =', r.value, '| RO =', finish(), '| tip =', kind, '| mod =', live ? 'live' : 'manual', '| link machetă actualizat =', !!(linkInput && linkInput.value));
      });
    });
    // Culoarea șuruburilor: se redesenează previzualizarea (+ linkul machetei), fără reconfirmare
    Array.prototype.forEach.call(screwRadios, function (r) {
      r.addEventListener('change', function () { schedule(false); });
    });
    // NOVA: culoarea textului = doar previzualizare (fără reconfirmare); fontul schimbă fișierul de decupare → reconfirmare
    Array.prototype.forEach.call(colorRadios, function (r) {
      r.addEventListener('change', function () { nlog('culoare text =', r.value); schedule(false); });
    });
    Array.prototype.forEach.call(fontRadios, function (r) {
      r.addEventListener('change', function () { nlog('font =', r.value); schedule(true); });
    });

    /* ---------- NOVA: logo-ul clientului ---------- */
    // Varianta „Cu logo” (+9,90) / „Fără logo” – butoanele temei, ascunse; se apasă automat după fișier
    function logoRadios() {
      if (!logoOpt) return [];
      return Array.prototype.slice.call(section.querySelectorAll('input[type="radio"][data-option-name="' + CSS.escape(logoOpt) + '"]'));
    }
    function setLogoVariant(on) {
      var radios = logoRadios();
      if (!radios.length) { if (logoOpt) nlog('opțiunea „' + logoOpt + '” nu există pe produs – fără taxă de logo'); return; }
      var target = radios.filter(function (r) { return on ? r.value === logoOn : r.value !== logoOn; })[0];
      if (target && !target.checked) { target.click(); nlog('variantă logo →', target.value); }
    }
    function logoVariantOn() {
      var r = logoRadios().filter(function (x) { return x.checked; })[0];
      return !!r && r.value === logoOn;
    }
    // 28.10 (HU NOVA): mesajele motorului NOVA sunt în RO → pe HU le înlocuim cu textele HU (data-i18n)
  function logoErrMsg(err) {
    var m = (err && err.message) || '';
    if (!hu) return m || 'Nu am putut citi logo-ul.';
    var hm = /^Format neacceptat/.test(m) ? T('nova_err_format', m) : /^Fișierul are peste 10 MB/.test(m) ? T('nova_err_size', m) : T('nova_logo_err', 'Nu am putut citi logo-ul.');
    console.log('[NDC-PERSO-HU] NOVA mesaj logo RO → HU:', m || '-', '→', hm);
    return hm;
  }
  function setLogoUi(msg, isError) {
      if (logoBox) logoBox.classList.toggle('ndc-logo--on', !!logo);
      if (logoRemove) logoRemove.hidden = !logo;
      if (logoLabel) logoLabel.textContent = msg || (logo ? T('nova_logo_chosen', '✓ {n} – apasă ca să alegi alt fișier').replace('{n}', logo.name) : logoDefaultLabel);
      if (isError) showError([msg]);
    }
    function clearLogo(reason) {
      logo = null;
      pendingLogo = null;
      setLogoVariant(false);
      if (logoInput) logoInput.value = '';
      nlog('logo scos (' + (reason || '-') + ')');
      setLogoUi();
    }
    function readLogo(file) {
      if (!engine) { pendingLogo = file; boot(); nlog('logo ales înainte de motor – aștept încărcarea'); return; }
      setLogoUi(T('nova_logo_loading', 'Se încarcă logo-ul…'));
      engine.prepareLogo(file).then(function (lg) {
        logo = lg;
        setLogoVariant(true);
        nlog('logo pregătit:', lg.name, '| tip', lg.kind, '| raport', Math.round(lg.ar * 100) / 100, '| ' + Math.round((lg.bytes || 0) / 1024) + ' KB');
        setLogoUi();
        hideError();
        schedule(true);
      }, function (err) {
        nlog('logo respins:', err && err.message);
        clearLogo('eroare');
        schedule(true);
        setLogoUi(logoErrMsg(err), true); // după schedule, ca mesajul să rămână vizibil
      });
    }
    if (logoInput) {
      logoInput.addEventListener('change', function () {
        var f = logoInput.files && logoInput.files[0];
        if (!f) { clearLogo('fără fișier'); schedule(true); return; }
        readLogo(f);
      });
    }
    if (logoRemove) {
      logoRemove.addEventListener('click', function () { clearLogo('buton'); schedule(true); });
    }
    // varianta „Cu logo” fără fișier (ex. link cu ?variant=) → înapoi la „Fără logo”
    if (nova && logoVariantOn() && !logo) { nlog('variantă „Cu logo” fără fișier la încărcarea paginii → Fără logo'); setLogoVariant(false); }
    if (ruleBox) {
      ruleBox.addEventListener('change', function () { nlog('linie de demarcație =', ruleBox.checked ? 'da' : 'nu'); schedule(true); });
    }

    // REX: altă siluetă = alt fișier de decupare → macheta se confirmă din nou
    Array.prototype.forEach.call(iconRadios, function (r) {
      r.addEventListener('change', function () { schedule(true); });
    });
    if (famToggle) {
      famToggle.addEventListener('change', function () {
        applyFamUi();
        setFamVariant(famToggle.checked);
        if (famToggle.checked) fam.focus();
        schedule(true);
      });
      section.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[data-option-name]')) setTimeout(syncFamFromVariant, 0);
      });
      syncFamFromVariant();
    }
    // Luxury / cutii: altă variantă (culoare / inserție) = altă machetă → se redesenează și se confirmă din nou
    if (lux || nova) {
      section.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[data-option-name], select')) setTimeout(function () { schedule(true); }, 30);
      });
    }
    confirmBox.addEventListener('change', function () {
      if (confirmBox.checked) {
        render();
        var p = problems();
        if (p.length) showError(p); else hideError();
      }
    });
    if (nightBtn) {
      nightBtn.addEventListener('click', function () {
        night = !night;
        nightBtn.setAttribute('aria-pressed', String(night));
        root.dataset.night = String(night);
        nightBtn.lastChild.textContent = night ? T('night_on', ' Vezi ziua') : T('night_off', ' Vezi noaptea');
        render();
      });
    }

    // Blocăm comanda (coș, plată rapidă, Releasit) până când textul/macheta e complet și confirmat
    // Câmpurile goale nu se trimit (altfel apar ca „Mențiuni: ” în coș și în comandă)
    function stripEmpty() {
      var off = [];
      document.querySelectorAll('[form="' + root.dataset.formId + '"][name^="properties["]').forEach(function (el) {
        var isText = el.tagName === 'TEXTAREA' || el.type === 'text' || el.type === 'hidden';
        if (isText && !el.disabled && !String(el.value).trim()) {
          el.disabled = true;
          off.push(el);
        }
        // NOVA: câmpul de fișier gol nu se trimite (altfel apare „Logo” gol în comandă)
        if (el.type === 'file' && !el.disabled && !(el.files && el.files.length)) {
          el.disabled = true;
          off.push(el);
        }
      });
      setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); }, 1500);
    }

    /* ---------- servicii opționale (Protecție colet, Livrare prioritară) ---------- */
    // Se adaugă în coș o singură dată pe comandă (cantitate 1), înainte ca tema să adauge produsul.
    function selectedServices() {
      return Array.prototype.filter.call(svcBoxes, function (b) { return b.checked && !b.disabled; })
        .map(function (b) { return b.value; });
    }
    function syncServicesUi() {
      section.classList.toggle('ndc-svc-on', selectedServices().length > 0); // ascunde „Cumpără acum” (ar ocoli coșul)
    }
    function addServices(ids) {
      var updates = {};
      ids.forEach(function (id) { updates[id] = 1; });
      return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }
    Array.prototype.forEach.call(svcBoxes, function (b) { b.addEventListener('change', syncServicesUi); });
    syncServicesUi();

    /* ---------- după adăugarea în coș: personalizatorul se golește pentru următorul produs ---------- */
    var addedAt = 0;
    function resetAfterAdd() {
      [street, number, textEl, other].forEach(function (el) { if (el) el.value = ''; });
      if (nova && logo) clearLogo('după adăugarea în coș');
      if (famToggle && famToggle.checked && fam) fam.value = '';
      confirmBox.checked = false;
      if (layoutRadios[0]) layoutRadios[0].checked = true;
      Array.prototype.forEach.call(svcBoxes, function (b) { b.checked = false; });
      syncServicesUi();
      applyOtherUi();
      hideError();
      render();
      if (caption) caption.textContent = I18N.added ? I18N.added.replace('{noun}', noun)
        : 'Am adăugat ' + noun + ' în coș. Poți personaliza ' + (root.dataset.more || 'încă unul') + ', cu alt text.';
    }
    document.addEventListener('shopify:cart:lines-update', function (ev) {
      if (!addedAt || Date.now() - addedAt > 15000 || ev.action !== 'add' || !ev.promise || !ev.promise.then) return;
      addedAt = 0;
      ev.promise.then(function () { setTimeout(resetAfterAdd, 400); }, function () {});
    });

    function firstMissing() {
      if (missingText()) return kind === 'placa' ? textEl : kind === 'apartament' ? number : (street || number);
      if (famToggle && famToggle.checked && !val(fam).trim()) return fam;
      if (isOther() && other && !other.value.trim()) return other;
      if (verifBlockingOpen()) return verifAckInput; // 29.10 #3411
      return confirmBox;
    }

    function guard(e, trigger) {
      var p = problems();
      if (!p.length) {
        famHuAplica('trimitere'); // NDC 17.10: „Kovács” → „Kovács család” și în proprietatea din comandă
        var svc = selectedServices();
        if (svc.length && !guard.svcDone) {
          e.preventDefault();
          e.stopImmediatePropagation();
          addServices(svc).catch(function () {}).then(function () {
            guard.svcDone = true;
            setTimeout(function () { guard.svcDone = false; }, 2000);
            if (trigger) trigger.click();
            else if (form && form.requestSubmit) form.requestSubmit();
          });
          return;
        }
        addedAt = Date.now();
        if (!guard.stripped) {
          guard.stripped = true;
          stripEmpty();
          setTimeout(function () { guard.stripped = false; }, 1500);
        }
        if (hu) {
          var props = [];
          document.querySelectorAll('[form="' + root.dataset.formId + '"][name^="properties["]').forEach(function (el) {
            if (el.disabled || ((el.type === 'radio' || el.type === 'checkbox') && !el.checked)) return;
            props.push(el.name + '=' + String(el.value).slice(0, 60));
          });
          console.log('[NDC-PERSO-HU] comandă trimisă cu proprietățile:', props.join(' | '));
        }
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(p);
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = firstMissing();
      setTimeout(function () { if (first) first.focus({ preventScroll: true }); }, 350);
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest(BUY_SELECTOR);
      if (!t || t.closest('[data-ndc-perso], cart-drawer-component, .cart-drawer, product-card')) return;
      if (t.closest('.shopify-section') && t.closest('.shopify-section') !== section && !t.hasAttribute('data-ndc-buy') && !/releasit|rsi[_-]/i.test(t.className + ' ' + t.id)) return;
      guard(e, t);
    }, true);
    if (form) form.addEventListener('submit', function (e) { guard(e, e.submitter || null); }, true);

    /* ---------- încărcare motor (doar modul live, când personalizatorul se apropie de ecran) ---------- */
    var booted = false;
    function boot() {
      if (booted || !live) return;
      booted = true;
      loadScript(root.dataset.opentypeUrl)
        .then(function () { return loadScript(root.dataset.engineUrl); })
        .then(function () { return window[engineGlobal].load(root.dataset.fontUrl, root.dataset.font2Url); })
        .then(function (api) {
          engine = api;
          root.classList.add('ndc-perso--ready');
          if (nova) {
            nlog('motor încărcat | font sans:', api.hasSans() ? 'da' : 'NU (se folosește fontul cu serife)');
            if (pendingLogo) { var pf = pendingLogo; pendingLogo = null; readLogo(pf); }
          }
          render();
        })
        .catch(function () {
          caption.textContent = T('load_fail', 'Macheta nu s-a putut încărca. Poți comanda în continuare – îți trimitem macheta pentru confirmare.');
        });
    }
    if (live) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) {
            io.disconnect();
            boot();
          }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else {
        boot();
      }
      ['focusin', 'pointerdown'].forEach(function (ev) { root.addEventListener(ev, boot, { once: true }); });
    }

    applyOtherUi();
    updateLayoutAvailability();
    if (!live) renderManual();
    console.log('[NDC-PERSO] init | tip =', kind, '| mod =', live ? 'live' : 'manual', '| produs lux =', luxProduct || '-',
      '| finisaj afișat =', root.dataset.finish, '| finisaj implicit =', finish() || '(fără)', '| NOVA =', nova);
    if (hu && nova) console.log('[NDC-PERSO-HU] NOVA init | opțiune logo =', logoOpt || '(lipsă)', '/', logoOn, '| culori =', colorRadios.length, '| fonturi =', fontRadios.length, '| mărime RO =', luxVariant(), '| culoare RO =', textColor(), '| font RO =', fontSel());
    if (hu) console.log('[NDC-PERSO-HU] init HU | texte =', Object.keys(I18N).length, '| valori traduse =', Object.keys(RO_MAP).length,
      '| opțiune model =', luxOpt, '| opțiune mărime =', luxSizeOpt || '-', '| opțiune familie =', famOption || '-', '/', famValue || '-',
      '| confirmare =', CONFIRM_PROP, '| model RO =', lux ? luxVariant() : '-');
  }

  function initAll() {
    document.querySelectorAll('[data-ndc-perso]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
